<template>
  <v-dialog
    v-model="show"
    width="40vw"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> Nuevo lote </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="loteForm" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12">
                <v-combobox
                  outlined
                  label="Selecciona tipo de lote"
                  dense
                  item-text="name"
                  v-model="type"
                  return-object
                  clearable
                  :items="types"
                  :rules="validation()"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Fecha de creación"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      :rules="validation()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    locale="es"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div v-if="type && type.value == 'L'">
              <v-row>
                <v-col>
                  <v-radio-group v-model="moTypeSelected">
                    <v-radio label="Bacteria" value="bacteria"></v-radio>
                    <v-radio label="Hongo" value="fungi"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="moTypeSelected && moTypeSelected == 'fungi'">
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    :search-input.sync="search"
                    item-text="serialReactivation"
                    label="Selecciona reactivacion"
                    return-object
                    clearable
                    no-data-text="No se encontro reactivación"
                    :loading="isLoadingReactivation"
                    v-model="reactivationFungi"
                    @keydown="cleanOldValue"
                    :items="reactivations"
                    dense
                    :disabled="moTypeSelected ? false : true"
                    chips
                    :rules="validation()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="reactivationFungi">
                  <v-text-field
                    label="Número de matraces iniciales (aproximados)"
                    dense
                    outlined
                    clearable
                    :rules="validation()"
                    v-model="flaskQty"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="reactivationFungi">
                  <v-checkbox
                    dense
                    v-model="isAvailableReactivation"
                    label="Utilizar toda la reactivación"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row v-if="moTypeSelected && moTypeSelected == 'bacteria'">
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    :search-input.sync="search"
                    item-text="serialReactivation"
                    label="Selecciona reactivacion"
                    return-object
                    clearable
                    no-data-text="No se encontro reactivación"
                    :loading="isLoadingReactivation"
                    v-model="reactivationBacteria"
                    @keydown="cleanOldValue"
                    :items="reactivations"
                    dense
                    :disabled="moTypeSelected ? false : true"
                    :multiple="true"
                    chips
                    :rules="validation()"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    reactivationBacteria &&
                    reactivationBacteria.find((element) =>
                      element.identificationName.includes(
                        'Streptomyces griseoviridis'
                      )
                    )
                  "
                >
                  <v-text-field
                    label="Número de matraces iniciales (aproximados)"
                    dense
                    outlined
                    clearable
                    :rules="validation()"
                    v-model="flaskQty"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    reactivationBacteria &&
                    !reactivationBacteria.find((element) =>
                      element.identificationName.includes(
                        'Streptomyces griseoviridis'
                      )
                    )
                  "
                >
                  <v-text-field
                    label="Litros proyectados"
                    dense
                    outlined
                    clearable
                    :rules="validation()"
                    v-model="projectetdLiters"
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div v-if="type && type.value == 'LB'">
              <v-row>
                <v-col cols="12">
                  <v-combobox
                    label="Selecciona tolva"
                    dense
                    outlined
                    clearable
                    return-object
                    :rules="validation()"
                    v-model="hopper"
                    :items="hoppers"
                    item-text="name"
                  ></v-combobox>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
export default {
  data: () => ({
    moTypeSelected: null,
    isLoading: false,
    isLoadingReactivation: false,
    reactivationBacteria: [],
    reactivationFungi: null,
    search: null,
    reactivations: [],
    types: [
      { name: "Microorganismos", value: "L" },
      { name: "Biofertilizante", value: "LB" },
    ],
    hoppers: [],
    projectetdLiters: null,
    type: null,
    isAvailableReactivation: false,
    flaskQty: null,
    hopper: null,
    user: JSON.parse(localStorage.getItem("user")),
    date: null,
    menu: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isLine() {
      return this.line ? false : true;
    },
  },
  methods: {
    ...mapActions("bioactives", ["searchReactivation"]),
    ...mapActions("lotes", ["addLotes", "addLotesFortisol", "getHoppers"]),
    ...mapMutations("lotes", ["SET_FETCH_LOTES_LIST"]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    closeModal() {
      this.isLoading = false;
      this.isLoadingReactivation = false;
      this.reactivationBacteria = [];
      this.reactivationFungi = null;
      this.search = null;
      this.reactivations = [];
      this.line = null;
      this.isAvailableReactivation = false;
      this.type = null;
      this.flaskQty = null;
      this.hopper = null;
      this.line = null;
      this.show = false;
      this.$refs.loteForm.resetValidation();
    },
    async confirmation() {
      //emit fetch table
      if (this.$refs.loteForm.validate()) {
        try {
          this.isLoading = true;
          if (this.type.value == "L") {
            let reactivations = [];
            if (this.moTypeSelected == "bacteria") {
              for (let item of this.reactivationBacteria) {
                reactivations.push(item._id);
              }
              this.isAvailableReactivation = true;
            } else {
              reactivations.push(this.reactivationFungi._id);
            }
            let payload = {
              reactivations: reactivations,
              isAvailableReactivation: this.isAvailableReactivation,
              flaskQty: this.flaskQty,
              user: this.user._id,
              projectetdLiters: this.projectetdLiters,
              date: this.date,
            };
            let response = await this.addLotes(payload);
            if (response) {
              if (!response.error) {
                //fetch data table again
                this.SET_FETCH_LOTES_LIST(true);
                //close ccurrent modal
                this.closeModal();
                //show success message
                this.$swal({
                  icon: "success",
                  title: `Lote creado con exito!!`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else {
                this.$swal({
                  icon: "error",
                  title: `Algo salio mal al crear lote`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
            } else {
              this.$swal({
                icon: "error",
                title: `Algo salio mal al crear lote`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } else {
            let payload = {
              user: this.user._id,
              hopper: this.hopper,
              date: this.date,
            };
            let response = await this.addLotesFortisol(payload);
            if (response) {
              if (!response.error) {
                //fetch data table again
                this.SET_FETCH_LOTES_LIST(true);
                //close ccurrent modal
                this.closeModal();
                //show success message
                this.$swal({
                  icon: "success",
                  title: `Lote creado con exito!!`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else {
                this.$swal({
                  icon: "error",
                  title: `Algo salio mal al crear lote`,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
            } else {
              this.$swal({
                icon: "error",
                title: `Algo salio mal al crear lote`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          }
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al crear lote`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
    cleanOldValue() {
      if (!this.search) {
        this.reactivation = null;
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
  },
  watch: {
    async search(value) {
      if (!value) return;
      else {
        this.isLoadingReactivation = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());
        try {
          const response = await this.searchReactivation({
            identification: value,
            moType: this.moTypeSelected,
          });
          if (response.error) throw response;

          this.reactivations = response.reactivationsFound;
        } catch (e) {
          console.log(e);
        }
        this.isLoadingReactivation = false;
      }
    },
    async type(item) {
      if (item.value == "LB") {
        try {
          let response = await this.getHoppers();
          if (response) {
            this.hoppers = response.hoppers;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async moTypeSelected() {
      this.isLoading = false;
      this.isLoadingReactivation = false;
      this.reactivationBacteria = [];
      this.reactivationFungi = null;
      this.search = null;
      this.reactivations = [];
      this.line = null;
      this.isAvailableReactivation = false;
      this.flaskQty = null;
      this.hopper = null;
      this.line = null;
      this.$refs.loteForm.resetValidation();
    },
    reactivationBacteria: {
      handler: function (val) {
        let count = 0;
        for (let item of val) {
          if (item.identificationName.includes("Streptomyces griseoviridis")) {
            count++;
          }
        }
        this.flaskQty = count;
      },
      deep: true,
    },
  },
};
</script>
